const ulTabs = document.querySelectorAll('ul.tabs li a');

if(ulTabs){
  let activeTabLink = ulTabs[0];
  activeTabLink.classList.add('active');
  let activeTabContentID = activeTabLink.getAttribute('href');
  document.querySelector(activeTabContentID).classList.add('active');
  
  ulTabs.forEach(function (tab) {
    tab.addEventListener('click', function (e) {
      activeTabLink.classList.remove('active');
      document.querySelector(activeTabContentID).classList.remove('active');
      activeTabLink = this;
      activeTabContentID = this.getAttribute('href');
      activeTabLink.classList.add('active');
      document.querySelector(activeTabContentID).classList.add('active');
      return false;
    });
  });
}
